/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { Modal } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetallSmtpGateways,
  Deletesmtpgateways,
} from "../Features/Smtpgatewaysdata";
import { RootState, AppDispatch } from "../Appstore/store";
import { setIsLoading } from "../Features/loadingSlice";
import { toast } from "sonner";
import { RenderPaginationButtons } from "../Components/Paginations";
import HelpText from "../Components/HelpText";
import { formatDate } from "../helper";

function Adminormonitors() {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [search, setSearch] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit = 10;
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const isActive = (path: string) =>
    location.pathname === path ? "active" : "";
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search);

  const { smtpgatewaysdata, info, loading } = useSelector(
    (state: RootState) => state.smtpgateways
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 800);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    dispatch(
      GetallSmtpGateways({ search: debouncedSearch, page: currentPage, limit })
    );
  }, [dispatch, debouncedSearch, currentPage, limit]);

  useEffect(() => {
    if (currentPage > info?.total_page!) setCurrentPage(info?.total_page || 1);
  }, [info]);

  const openDeleteModal = (id: number) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedId(null);
  };

  const confirmDelete = async () => {
    if (selectedId !== null) {
      dispatch(setIsLoading(true));
      const resp: any = await dispatch(Deletesmtpgateways({ id: selectedId }));
      if (resp?.payload?.status === "success")
        toast.success(resp?.payload?.message || "");
      else toast.error(resp?.payload?.message || "");
      setTimeout(() => {
        dispatch(setIsLoading(false));
      }, 500);
      dispatch(
        GetallSmtpGateways({
          search: debouncedSearch,
          page: currentPage,
          limit,
        })
      );
    }
    closeDeleteModal();
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="wrapper">
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card mt-4">
              <div className="card-header bg-white p-3 d-md-flex justify-content-md-between align-items-center">
                <h2 className="w-100 text-md-start text-center mb-md-2 mb-3 fs-3">
                  SMTP Gateways
                </h2>
                <div className="d-sm-flex justify-content-between align-items-center mb-md-0 mb-3">
                  <div className="input-group input-group-sm pe-sm-3 mb-sm-0 mb-3 search-input">
                    <input
                      type="search"
                      className="form-control float-right height-40px shadow-none"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <div className="input-group-append">
                      <button
                        type="submit"
                        className="btn border cursor-pointer-none"
                      >
                        <i className="fas fa-search" />
                      </button>
                    </div>
                  </div>
                  <Link
                    to="/admin/smtp-gateways/add"
                    className={`nav-link ${isActive("/admin/smtp-gateways")}`}
                  >
                    <button
                      data-tooltip-id="Add_Btn"
                      className="border-0 bg-button btn btn-primary text-white rounded-0 text-secondary w-100 px-2 py-2 fw-semibold d-flex justify-content-center align-items-center"
                    >
                      <IoMdAdd className="fs-4" />
                      <HelpText id="Add_Btn" content="Add SMTP Gateway" />
                    </button>
                  </Link>
                </div>
              </div>
              <div className="card-body p-0">
                <>
                  <div className="table-responsive">
                    <table className="table table-hover table-bordered text-nowrap">
                      <thead>
                        <tr>
                          <th className="ps-3 sr-no">SR No</th>
                          <th>Gateway Name</th>
                          <th>SMTP Gateway</th>
                          <th>From Email</th>
                          <th>Created At</th>
                          <th className="text-center action">Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={7} height={100}>
                              <div className="text-center">
                                <div className="loader"></div>
                              </div>
                            </td>
                          </tr>
                        ) : !smtpgatewaysdata ||
                          smtpgatewaysdata.length === 0 ? (
                          <tr>
                            <td colSpan={7} height={50}>
                              <div className="text-center">
                                <p className="mb-0 fs-5 fw-semibold">
                                  No data found
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          smtpgatewaysdata.map((item, index) => (
                            <tr key={item.id}>
                              <td className="ps-3">
                                {(currentPage - 1) * limit + index + 1}
                              </td>
                              <td>{item.gateway_name}</td>
                              <td>
                                {item.smtp_gateway === 1
                                  ? "Google"
                                  : item.smtp_gateway === 2
                                  ? "Microsoft"
                                  : ""}
                              </td>
                              <td className="">{item.from_email}</td>
                              <td className="">{formatDate(item.createdAt)}</td>
                              <td className="text-center">
                                <Link
                                  to={`/admin/smtp-gateways/view/${item.id}`}
                                >
                                  <button className="ms-1 bg-transparent border-0 text-success fs-5">
                                    <i
                                      data-tooltip-id={"View_Btn_" + index}
                                      className="fa-solid fa-eye"
                                    ></i>
                                    <HelpText
                                      id={"View_Btn_" + index}
                                      content="View SMTP Gateway"
                                    />
                                  </button>
                                </Link>
                                <Link
                                  to={`/admin/smtp-gateways/update/${item.id}`}
                                >
                                  <button className="ms-1 bg-transparent border-0 text-primary fs-5">
                                    <i
                                      data-tooltip-id={"Update_Btn_" + index}
                                      className="fa-solid fa-pen"
                                    ></i>
                                    <HelpText
                                      id={"Update_Btn_" + index}
                                      content="Update SMTP Gateway"
                                    />
                                  </button>
                                </Link>
                                <button
                                  onClick={() => openDeleteModal(item.id!)}
                                  className="ms-1 bg-transparent border-0 text-danger fs-5"
                                >
                                  <i
                                    data-tooltip-id={"Delete_Btn_" + index}
                                    className="fa-solid fa-trash"
                                  ></i>
                                  <HelpText
                                    id={"Delete_Btn_" + index}
                                    content="Delete SMTP Gateway"
                                  />
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {!smtpgatewaysdata || smtpgatewaysdata.length === 0 ? (
                    <div></div>
                  ) : (
                    <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                      <RenderPaginationButtons
                        info={info}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>
        </section>

        <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
          <div className="p-3">
            <div className="text-center">
              <i
                style={{ fontSize: "50px" }}
                className="text-danger bi bi-info-circle"
              ></i>
            </div>
            <Modal.Header className="d-block border-0 p-2 text-center">
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body className="border-0 text-center p-2">
              Are you sure you want to delete this SMTP Gateway
            </Modal.Body>
            <Modal.Footer className="border-0 justify-content-center">
              <button className="btn btn-danger" onClick={confirmDelete}>
                Delete
              </button>
              <button className="btn btn-secondary" onClick={closeDeleteModal}>
                Cancel
              </button>
            </Modal.Footer>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default Adminormonitors;
